var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mb-6"},[_c('v-card-title',[_vm._v("Halo! Selamat datang di OriensCRM 🚀")]),_c('v-card-text',[_vm._v("Semoga harimu menyenangkan!")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }